import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
app.initializers.add('clarkwinkelmann-author-change', () => {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!app.forum.attribute('clarkwinkelmannAuthorChangeCanEditUser') && !app.forum.attribute('clarkwinkelmannAuthorChangeCanEditDate')) {
      return;
    }
    items.add('clarkwinkelmann-author-change', Button.component({
      icon: 'fas fa-user-edit',
      onclick() {
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/UpdateAuthorModal', webpackMode: 'lazy-once' */ './components/UpdateAuthorModal'), {
          related: discussion
        });
      }
    }, app.translator.trans('clarkwinkelmann-author-change.forum.controls.edit')));
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    if (!app.forum.attribute('clarkwinkelmannAuthorChangeCanEditUser') && !app.forum.attribute('clarkwinkelmannAuthorChangeCanEditDate')) {
      return;
    }
    items.add('clarkwinkelmann-author-change', Button.component({
      icon: 'fas fa-user-edit',
      onclick() {
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/UpdateAuthorModal', webpackMode: 'lazy-once' */ './components/UpdateAuthorModal'), {
          related: post
        });
      }
    }, app.translator.trans('clarkwinkelmann-author-change.forum.controls.edit')));
  });
});flarum.reg.addChunkModule('753', '562', 'clarkwinkelmann-author-change', 'forum/components/UpdateAuthorModal');
flarum.reg.addChunkModule('753', '562', 'clarkwinkelmann-author-change', 'forum/components/UsersSearchSourceWithoutInternalRouting');
flarum.reg.addChunkModule('753', '562', 'clarkwinkelmann-author-change', 'forum/components/UserSearch');